module.exports = __webpack_public_path__ + "static/media/lenders-stock.e3a8a22c.png";